import Cookies from 'js-cookie'
import moment from 'moment'
import Base64 from 'crypto-js/enc-base64'
import enc from 'crypto-js/enc-utf8'
import md5 from 'crypto-js/md5'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
/**
 * 处理小于10的数字
 * @param num
 * @returns
 */
const formatLessThan10Num = (num: number): string => {
  return num < 10 ? `0${num}` : `${num}`
}

/**
 * 获取最近几分钟时间
 * @param num
 * @returns
 */
export const getLastFewMinutes = (num = 5) => {
  const time = new Date()
  const year = time.getFullYear()
  const month = formatLessThan10Num(time.getMonth() + 1)
  const date = formatLessThan10Num(time.getDate())
  const hour = formatLessThan10Num(time.getHours())
  const minute = time.getMinutes()
  const lastFewminute = formatLessThan10Num(minute - (minute % num))
  return `${year}${month}${date}${hour}${lastFewminute}`
}

/**
 * 获取url上的query参数
 * @returns
 */
export const getUrlQuery = (url: string) => {
  const search = url.split('?')[1]
  const keyValueArr = search.split('&')
  const query: Record<string, string> = {}
  keyValueArr.forEach((keyValue) => {
    const [key, value] = keyValue.split('=')
    query[key] = decodeURIComponent(value)
  })
  return query
}

/**
 * 获取当前url上的query参数
 * @returns
 */
export const getCurrentUrlQuery = () => {
  const search = window.location.search.replace('?', '')
  const keyValueArr = search.split('&')
  const query: Record<string, string> = {}
  keyValueArr.forEach((keyValue) => {
    const [key, value] = keyValue.split('=')
    query[key] = decodeURIComponent(value)
  })
  return query
}

/**
 * 获取浏览器版本
 * @returns
 */
export const browerVersion = () => {
  const { userAgent } = navigator
  const userIdMatchs = userAgent.match(/userId\/(.*?) /)
  const weixinVersion = userAgent.match(/MicroMessenger\/([\d.]+)/i)
  return {
    mobile: !!userAgent.match(/AppleWebKit.*Mobile.*/),
    ios: !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    android: userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1,
    iPhone: userAgent.indexOf('iPhone') > -1,
    iPad: userAgent.indexOf('iPad') > -1,
    weixin: userAgent.indexOf('MicroMessenger') > -1,
    myApp: userAgent.indexOf('pdmiryun') > -1,
    rmcb: userAgent.indexOf('rmcb') > -1,
    userId: userIdMatchs?.length ? userIdMatchs[1].replace(/ /g, '') : '',
    iframe: window.self !== window.top,
    windowWeixin: userAgent.indexOf('WindowsWechat') > -1,
    macWeixin: userAgent.indexOf('MacWechat') > -1,
    wxVersion: weixinVersion && weixinVersion.length ? weixinVersion[1] : 0,
    wxWork: userAgent.indexOf('WxWork') > -1,
    miniProgram: userAgent.indexOf('miniProgram') > -1,
    harmonyOS: userAgent.includes('OpenHarmony') || userAgent.includes('ArkWeb'),
  }
}

/**
 * 导入js文件
 * @param url
 * @param name
 * @returns
 */
export const loadScript = (url: string, name?: string) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    if (name) {
      const scriptElement = document.querySelector(`script[name="${name}"]`)
      if (scriptElement) {
        resolve(true)
        return
      }
      script.setAttribute('name', name)
    }
    script.onload = () => {
      resolve(true)
    }
    script.onerror = (err) => {
      reject(err)
    }
    script.src = url
    document.getElementsByTagName('html')[0].append(script)
  })
}

/**
 * 业务中台接口验签
 * @param path
 * @param params
 * @returns
 */
export const mediaApiSign = (path: string, params: Record<string, string | number>) => {
  const keys = Object.keys(params)
  const querys = keys.map((key) => {
    return `${key}${params[key]}`
  })
  querys.sort()
  const nonce = Math.floor(Math.random() * 100000)
  const timestamp = Date.now()
  const plaintext = `${timestamp}${import.meta.env.VITE_MEDIA_API_APPID}${nonce}${path}${querys.join('')}`
  const signature = md5(`${plaintext}${import.meta.env.VITE_MEDIA_API_APPSECRET}`)
    .toString()
    .toLocaleUpperCase()
  return {
    'x-nr-appid': import.meta.env.VITE_MEDIA_API_APPID,
    'x-nr-timestamp': timestamp,
    'x-nr-nonce': nonce,
    'x-nr-signature': signature,
  }
}

/**
 * 业务中台登录部分接口验签
 * @param appid
 * @param token
 * @returns
 */
export function mediaAuthAndSign(appid?: string, token?: string) {
  const timestamp = moment().format('YYYYMMDDHHmmss')
  return {
    sign: md5(
      `${appid || import.meta.env.VITE_MEDIA_APPID}${token || import.meta.env.VITE_MEDIA_APPTOKEN}${timestamp}`,
    ).toString(),
    auth: Base64.stringify(enc.parse(`${appid || import.meta.env.VITE_MEDIA_APPID}:${timestamp}`)),
  }
}

/**
 * 根据新闻稿件url提取稿件发布的年、月、日、稿件id
 * @param {String} newsUrl
 * @returns
 */
export const formatNewsUrlParams = (newsUrl: string) => {
  if (!newsUrl) {
    return false
  }
  const newsUrlArr = newsUrl.split('/')
  let newsUrlArrIndex = -1
  const reg = /^[0-9]+$/
  for (let i = 0; i < newsUrlArr.length; i += 1) {
    if (reg.test(newsUrlArr[i])) {
      newsUrlArrIndex = i
      break
    }
  }
  const params = {
    year: newsUrlArr[newsUrlArrIndex],
    month: newsUrlArr[newsUrlArrIndex + 1],
    date: newsUrlArr[newsUrlArrIndex + 2],
    newsId: newsUrlArr[newsUrlArrIndex + 3].split('.')[0],
  }
  return params
}

/**
 * 格式化稿件时间
 * @param timestr
 * @returns
 */
export const formatNewsTime = (timestr: string): string => {
  if (!timestr) {
    return ''
  }
  const replaceTime = timestr.replace(/-/g, '/')
  const timestamp = new Date(replaceTime).getTime()
  const currentTimestamp = new Date().getTime()
  const h24Timestamp = 24 * 60 * 60 * 1000
  const m60Timestamp = 60 * 60 * 1000
  let result = ''
  if (currentTimestamp - timestamp < m60Timestamp) {
    const min = Math.ceil((currentTimestamp - timestamp) / (60 * 1000))
    result = `${min}分钟前`
  } else if (currentTimestamp - timestamp < h24Timestamp) {
    const h = Math.ceil((currentTimestamp - timestamp) / (60 * 60 * 1000))
    result = `${h}小时前`
  } else {
    const time = new Date(replaceTime)
    const cTime = new Date()
    const y = time.getFullYear()
    const cy = cTime.getFullYear()
    let m: number | string = time.getMonth() + 1
    let d: number | string = time.getDate()
    m = m < 10 ? `0${m}` : m
    d = d < 10 ? `0${d}` : d
    if (y === cy) {
      result = `${m}月${d}日`
    } else {
      result = `${y}年${m}月${d}日`
    }
  }
  return result
}

/**
 * 获取浏览器指纹
 * @returns
 */
export const getBrowerAppId = async (): Promise<string> => {
  const cacheAppId = Cookies.get('fingerprint')
  if (cacheAppId) {
    return cacheAppId
  } else {
    const fpPromise = FingerprintJS.load()
    const fp = await fpPromise
    const { visitorId } = await fp.get()
    Cookies.set('fingerprint', visitorId, { expires: 365 })
    return visitorId
  }
}
